import "@formatjs/intl-locale/polyfill";
import "@formatjs/intl-pluralrules/polyfill";
import "@formatjs/intl-pluralrules/locale-data/en";
import "@formatjs/intl-pluralrules/locale-data/de";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/de";
import "@formatjs/intl-relativetimeformat/locale-data/en";
import { useMemo } from "react";
import { IntlProvider } from "react-intl";
import { withConfiguration } from "../context/ConfigurationContext";
import TRANSLATIONS, { getTranslations } from "../translations";

type Props = {
  children: React.ReactNode;
  mergeAppMessages?: $TSFixMeFunction;
  configuration?: {
    language: string;
  };
};

export function Intl({
  children,
  // @ts-expect-error TS(2322) FIXME: Type '{ language: string; locale: string; }' is no... Remove this comment to see the full error message
  configuration = { language: "en", locale: "en" },
  mergeAppMessages = () => {},
}: Props) {
  useMemo(() => {
    mergeAppMessages(configuration.language);
    getTranslations(configuration.language);
  }, []);

  return (
    <IntlProvider
      locale={(configuration as $TSFixMe).locale}
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      messages={TRANSLATIONS[configuration.language]}
    >
      {children}
    </IntlProvider>
  );
}

export default withConfiguration(Intl);
